module.exports = __webpack_public_path__ + "img/caifuzhongxin.2c7277b8.jpg";